"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryActivityList = void 0;
const TimeUtil_1 = require("../../utils/TimeUtil");
class HistoryActivityList extends Array {
    constructor() {
        super(...arguments);
        this.getDateStartSorted = () => {
            const activityList = new HistoryActivityList();
            if (this.length > 0) {
                this.sort((x, y) => {
                    const dateAwardedX = !!x.date_awarded ? x.date_awarded : 0;
                    const dateAwardedY = !!y.date_awarded ? y.date_awarded : 0;
                    return dateAwardedX > dateAwardedY ? -1 : 1;
                })
                    .forEach(x => {
                    const baseNumPoints = parseInt(x.base_num_points, 10);
                    if (x.num_points !== baseNumPoints && baseNumPoints > 0 && x.num_points > baseNumPoints) {
                        x.bonusPoints = x.num_points - baseNumPoints;
                    }
                    x.dateAwarded =
                        x.date_awarded !== null ? (0, TimeUtil_1.formatUnixMonthOrdinalDayYear)(x.date_awarded) : null;
                    activityList.push(x);
                });
            }
            return activityList;
        };
    }
}
exports.HistoryActivityList = HistoryActivityList;
//# sourceMappingURL=HistoryActivityList.js.map